import { useEffect } from "react";

/**
 * Calls `action` once, `ms` after mount; `false` leaves the screen without a timer. Pure elapsed time since mount,
 * not reset by interaction, so a re-render with the same `ms` does not restart the countdown.
 */
export const useReturnAfterIdle = (ms: number | false, action: () => void) => {
  useEffect(() => {
    if (ms === false) return;
    const timer = setTimeout(action, ms);
    return () => clearTimeout(timer);
    // `action` is read once per activation: including it would restart the countdown on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ms]);
};
